import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule, MatIconModule } from '@angular/material';
import { FcOutlinedInputComponent } from './fc-outlined-input.component';

@NgModule({
  declarations: [
    FcOutlinedInputComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,

    MatIconModule,
    MatButtonModule
  ],
  exports: [
    FcOutlinedInputComponent
  ]
})
export class FcOutlinedInputModule { }
